<template>
<div class="balance-container">
  <div class="row">
    <div class="col-sm-12 col-md-6 mb-4 mt-4">
      <div class="card">
        <div class="card-header h5">
          {{ $t('balance_history.topup') }}
        </div>
        <div class="card-block">
          <form @submit.prevent="handleSubmitTopup" data-vv-scope="form-topup">
            <div class="form-group">
              <input type="text" :placeholder="$t('balance_history.amount')" v-model="topupAmount"  v-validate="{ required: true, max: 12 }" name="amount" class="form-control" :class="{ 'is-invalid': submitted && errors.has('form-topup.amount') }" :data-vv-as="$t('balance_history.amount')" @keypress="isNumber($event)"/>
              <div>{{ topupAmountString + ' ' + $t('balance_unit') }}</div>
              <div v-if="submitted && errors.has('form-topup.amount')" class="invalid-feedback">{{ errors.first('form-topup.amount') }}</div>
            </div>
            <div class="col-md-12">
              <button class="btn btn-primary">{{ $t('balance_history.topup_submit') }}</button>
              <img v-if="false" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 mb-4 mt-4">
      <div class="card">
        <div class="card-header h5">
          {{ $t('balance_history.title') }}
        </div>
        <div class="card-block">
          <b-table v-if="balanceItems.hasOwnProperty('items')" striped hover :items="balanceItems.items" :fields="fields">
            <template #cell(run_id)="data">
              <i v-if="data.value === '*topup'" class="fa fa-plus type-plus" aria-hidden="true"></i>
              <i v-else class="fa fa-minus type-minus" aria-hidden="true"></i>
            </template>
            <template #cell(cost)="data">
              {{ data.value | tsformat }}
            </template>
            <template #cell(setup_time)="data">
              {{ data.value | jdateformat }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Num2persian from 'num2persian'
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    DatePicker
  },
  data () {
    return {
      topupAmountStorage: 0,
      fields: [
        {
          key: 'run_id',
          label: ''
        },
        {
          key: 'cost',
          label: this.$t('balance_history.amount')
        },
        {
          key: 'setup_time',
          label: this.$t('balance_history.date_time')
        }
      ],
      submitted: false
    }
  },
  computed: {
    ...mapState({
      balanceItems: state => state.account.balanceHistory
    }),
    topupAmount: {
      get: function () {
        return this.$options.filters.tsformat(this.topupAmountStorage)
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.topupAmountStorage = 0
          return
        }
        this.topupAmountStorage = parseInt(newValue.replace(/,/g, ''))
      }
    },
    topupAmountString: function () {
      return Num2persian(this.topupAmountStorage)
    }
  },
  mounted () {
    this.balanceHistory()
  },
  methods: {
    ...mapActions('account', ['balanceHistory']),
    handleSubmitTopup () {
      this.submitted = true
      this.$validator.validateAll('form-topup').then(valid => {
        if (valid) {
          console.log('topup')
        }
      })
    },
    isNumber (evt) {
      evt = evt || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style>
.type-plus {
  color: var(--balance-history-type-plus-color);
}

.type-minus {
  color: var(--balance-history-type-minus-color);
}
</style>



// WEBPACK FOOTER //
// src/views/BalanceHistory.vue